<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройки доставки</strong>
                </CCardHeader>
                <CCardBody>
                    <p class="py-2">
                        <strong>Аптеки</strong><br />Укажите идентификаторы помощника и
                        услуги. При создании заказов из аптек будет создан заказ данной
                        услуги в качестве доставки.
                    </p>
                    <CRow>
                        <CCol sm="6">
                            <CInput
                                v-model="delivery.pharmacy.assistant_id"
                                label="ID помощника"
                                placeholder="Введите ID помощника..."
                            />
                        </CCol>
                        <CCol sm="6">
                            <CInput
                                v-model="delivery.pharmacy.service_id"
                                label="ID услуги"
                                placeholder="Введите ID услуги..."
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'DeliverySettings',

        components: {},

        icons: {},

        data() {
            return {
                key: 'delivery',
                delivery: {
                    pharmacy: {
                        assistant_id: '',
                        service_id: '',
                    },
                },
            };
        },

        mounted() {
            this.fetch();
        },

        methods: {
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: this.delivery,
                    })
                    .then(resp => {
                        this.delivery = resp.data.value;
                        this.$root.$emit('showAlert', 'Успешно');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения данных: ' + err);
                    });
            },
            fetch() {
                Vue.axios.get('/settings/' + this.key).then(resp => {
                    if (resp.data.value) {
                        this.delivery = resp.data.value;
                    } else {
                        this.delivery = {
                            pharmacy: {
                                assistant_id: '',
                                service_id: '',
                            },
                        };
                    }
                });
            },
        },
    };
</script>
